<script>
import { exitFullScreen } from "@/common/util.js";

export default {
  data() {
    return {
      value: "",
      isStart: false,
      finished: false,
      eData: "",
      isScreen: false
    };
  },
  mounted() {
    this.$el.lastElementChild.src = `${this.$resourceUrl}/shigongnengjiance-worth4dot/index.html`;
    this.fullScreen();
    window.addEventListener("message", this.getMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.getMessage);
    exitFullScreen();
  },
  methods: {
    getMessage(e) {
      if (this.isJsonString(e.data)) {
        // this.finished = true;
        let data = e.data;
        data = JSON.parse(data);
        if (data.type === "saveBtnClicked") {
          localStorage.setItem("worthFour", JSON.stringify(data.data));
          this.saveFinshedResult(data.data);
        } else if (data.type === "getPixelInfo") {
          let messData = JSON.parse(localStorage.getItem("data"));
          document.querySelector(".ScreenIframe").contentWindow.focus();
          let jsonData = JSON.stringify({
            type: "getPixelInfo",
            data: messData
            // client: 'vision-challenge'
          });
          window.frames[0].postMessage(jsonData, "*");
        } else if (data.type === "quit") {
          this.$router.replace("/index/homeRoute");
        }
      }
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {}
      return false;
    },
    goBack() {
      this.$router.replace("/index/homeRoute");
    },
    fullScreen() {
      var element = this.$el.lastElementChild;
      var requestMethod =
        element.requestFullScreen || //W3C
        element.webkitRequestFullScreen || //FireFox
        element.mozRequestFullScreen || //Chrome等
        element.msRequestFullscreen; //IE11
      if (requestMethod) {
        requestMethod.call(element);
      }
    },
    async saveFinshedResult(testResult) {
      const data = {
        result: testResult,
        type: "WORTH_FOUR_LAMP_HOLE_CHALLENGE"
      };
      const result = await this.$http.admin.saveTestResult(data);
      if (!result) {
        this.$message.warning("保存失败，请重新进行测试！");
      }
      if (this.$route.path !== "/index/homeRoute") {
        this.$router.replace("/index/homeRoute");
      }
    }
  }
};
</script>
<template>
  <div class="TrainIframe" element-loading-background="rgba(0, 0, 0, 0.3)">
    <iframe class="ScreenIframe" frameborder="no"></iframe>
  </div>
</template>

<style lang="scss">
.TrainIframe .container {
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #00c1de;
  }
  .el-input__inner:focus {
    border-color: #00c1de;
  }
}
</style>
<style lang="scss" scoped>
.el-select-dropdown__item.selected {
  color: #00c1de;
}
.TrainIframe {
  width: 99%;
  height: 96%;
}
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-grow: 1;
  // margin: 15px;
  background-color: #fff;
  border-radius: 5px;
  overflow: auto;
}
.ScreenIframe {
  width: 100%;
  height: 99%;
}
.text {
  margin-bottom: 24px;
  margin: 0 23px 24px 23px;
  text-align: center;
  color: #343434;
  font-size: 18px;
  .selectBox {
    margin-top: 20px;
  }
}
</style>







// WEBPACK FOOTER //
// src/components/vision/worthFour.vue